import BaseAPI from './base.api';

export default class AiAnalyticsAPI extends BaseAPI {
  getProductivityAnalysis = async () => {
    const response = await this.API.get(
      'ai-analytics/get-productivity-ai-analysis',
      {
        params: { customerId: this.customerId },
      }
    );
    return response.data;
  };

  getProductivityLastHoursAnalysis = async (
    date: string,
    lastHours: number
  ) => {
    const response = await this.API.get(
      'ai-analytics/productivity-last-hours-analysis',
      {
        params: { customerId: this.customerId, date, lastHours },
      }
    );
    return response.data;
  };

  getFuelAnalysis = async () => {
    const response = await this.API.get('ai-analytics/get-fuel-ai-analysis', {
      params: { customerId: this.customerId },
    });
    return response.data;
  };
}
